module.exports = __webpack_public_path__ + "static/img/table.c1a6e60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/table.svg
// module id = YR/l
// module chunks = 2